import { render, staticRenderFns } from "./IndiaMap.vue?vue&type=template&id=5664adfd"
import script from "./IndiaMap.vue?vue&type=script&lang=js"
export * from "./IndiaMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports